import { TranslateService } from 'shared';

export class AgGridUserGroupRoleSettings {

  constructor(private translate: TranslateService) { }

  public agGridProjectUserGroupRolesSettings = {
    rowModelType: 'infinite' as any,
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: { mode: 'singleRow', checkboxes: false } as any,
    //rowDeselection: true,
    rowHeight: 65,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 1,
    columnDefs: [
      { field: 'name', headerName: `${this.translate.data["SUBTITLEPROJECTUSERGROUPROLES"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true }
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  };

}